import PromiseQueue, { TPromiseFunction } from "./promiseQueue";

/**
 * Provides a way to have a series of homogeneous promise queue requests during a long-ish running operation to merge
 * into one queued promise after the current operation is complete.
 *
 * Mostly useful only for GetFeed related calls
 */
export default class PromiseDebounce {
    /**
     * The PromiseQueue to wrap
     */
    private readonly promiseQueue: PromiseQueue;

    /**
     * The constructor
     * @param log A function callback to log messages
     * @param errorLog A function callback to log errors
     * @param errorHandler An error handler
     * @param timeout The timeout for a promise in this system to prevent deadlocking
     */
    constructor(log: (message: string) => void, errorLog: (message: string) => void, errorHandler: Function, timeout = 180000) {
        this.promiseQueue = new PromiseQueue(log, errorLog, errorHandler, timeout);
    }

    /**
     * Attempts to add a promisequeue item unless there is already a pending promise
     * @param callback The action to run
     */
    run(callback: TPromiseFunction): PromiseQueue {
        if (this.promiseQueue.length <= 1) {
            void this.promiseQueue.push(callback);
        }
        return this.promiseQueue;
    }

    /**
     * Empties the promise queue by resetting (cancelling)
     * @returns Reset {@link PromiseQueue}
     */
    reset() {
        this.promiseQueue?.reset && this.promiseQueue.reset();
        return this.promiseQueue;
    }
}